import { InputText } from 'primereact/inputtext';
import '../App.css';
import { Button } from 'primereact/button';

function CampaignNewStepTitle({
    title,
    setTitle,
    setStep,
}) {
    return (
        <div>
            <div className='mk2-title'>
                Create campaign
            </div>
            <div className='mk2-subtitle'>
                Title
            </div>
            <InputText
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder='campaign title'
                style={{
                    marginTop: '1em',
                }}
            />
            <div style={{ marginTop: '2em' }}>
                <Button
                    label='Continue'
                    severity='success'
                    onClick={() => setStep('upload')}
                    disabled={title == null || title == ''}
                    size='small'
                    outlined
                />
            </div>

        </div>
    );
}

export default CampaignNewStepTitle;